export const actionTypes = {
  REQUEST_START: 'APP.FEEDBACK.REQUEST_START',
  REQUEST_SUCCESS: 'APP.FEEDBACK.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'APP.FEEDBACK.REQUEST_FAILURE',
  REQUEST_THEMES_START: 'APP.FEEDBACK.REQUEST_THEMES_START',
  REQUEST_THEMES_SUCCESS: 'APP.FEEDBACK.REQUEST_THEMES_SUCCESS',
  REQUEST_THEMES_FAILURE: 'APP.FEEDBACK.REQUEST_THEMES_FAILURE',
  OPEN_MODAL: 'APP.FEEDBACK.OPEN_MODAL',
  CLOSE_MODAL: 'APP.FEEDBACK.CLOSE_MODAL',
  RESET: 'APP.FEEDBACK.RESET',
};

export function requestStart(payload) {
  return {
    type: actionTypes.REQUEST_START,
    payload,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function openModal() {
  return {
    type: actionTypes.OPEN_MODAL,
  };
}

export function closeModal() {
  return {
    type: actionTypes.CLOSE_MODAL,
  };
}

export function requestThemesStart() {
  return {
    type: actionTypes.REQUEST_THEMES_START,
  };
}

export function requestThemesSuccess(payload) {
  return {
    type: actionTypes.REQUEST_THEMES_SUCCESS,
    payload,
  };
}

export function requestThemesFailure(error) {
  return {
    type: actionTypes.REQUEST_THEMES_FAILURE,
    error,
  };
}

export function reset() {
  return {
    type: actionTypes.RESET,
  };
}
